import styled from "styled-components"

import { Banner, colors, Text } from "@minuthq/meatball-ui-react"

import { chargebeeSubscriptionUrl } from "src/constants/hrefs"
import { TFetchCurrentSubscriptionResponse } from "src/data/billing/types/billingTypes"
import { translatePlanName } from "src/data/user/logic/userPlan"
import { useTranslate } from "src/i18n/useTranslate"
import { Divider } from "src/ui/Divider/Divider"
import { ExternalLink } from "src/ui/Link/ExternalLink"
import { MBadge, MBadgeProps } from "src/ui/MBadge/MBadge"
import { spacing } from "src/ui/spacing"
import { formatUtcDate } from "src/utils/l10n"

export function ParadiseUserSubscription({
  subscription,
}: {
  subscription?: TFetchCurrentSubscriptionResponse | null
}) {
  const { t } = useTranslate()

  if (!subscription) {
    return (
      <Banner type="info" fullWidth>
        No subscription found
      </Banner>
    )
  }

  return (
    <div>
      <Text variant="heading2">
        {translatePlanName(t, subscription.plan, subscription.legacy_plan)}
      </Text>
      <Text variant="bodyS">{subscription.plan_id}</Text>

      <ExternalLink
        href={chargebeeSubscriptionUrl(subscription.subscription_id)}
      >
        View in Chargebee
      </ExternalLink>

      <Divider $margin={spacing.L} />

      <InfoRow>
        <div>
          <Text variant="bodyXS">Status</Text>
          <MBadge
            color={getStatusColor(subscription.subscription_status)}
            size="small"
          >
            {subscription.subscription_status}
          </MBadge>
        </div>
        <div>
          <Text variant="bodyXS">Billing model</Text>
          <MBadge size="small">{subscription.billing_model}</MBadge>
        </div>
        <div>
          <Text variant="bodyXS">Billing period</Text>
          {subscription.billing_period}
        </div>
        <div>
          <Text variant="bodyXS">Next invoice</Text>
          <Text variant="bodyS">
            {subscription.next_billing_at
              ? formatUtcDate({
                  date: subscription.next_billing_at,
                  excludeTime: true,
                })
              : "-"}
          </Text>
        </div>
      </InfoRow>
    </div>
  )
}

function getStatusColor(
  status: TFetchCurrentSubscriptionResponse["subscription_status"]
): MBadgeProps["color"] {
  switch (status) {
    case "active":
      return "good"
    case "non_renewing":
      return "warning"
    case "cancelled":
      return "error"
    default:
      return "neutral"
  }
}

const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.L};

  > div:not(:last-child) {
    border-right: 1px solid ${colors.divider};
    padding-right: ${spacing.S};
  }
`
